<script lang="tsx">
  import LoadingSpinner from './LoadingSpinner.vue'

  export default LoadingSpinner
</script>
